import {
  Box,
  Grid,
  GridItem,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Text,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from '@chakra-ui/react'
import { FC } from 'react'
import { FaSave } from 'react-icons/fa'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'
import useAuth from '@hook/shared/use-auth'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import LayoutTools from '@component/Layout/Tools'
import { PurchaseSchedule } from '@component/Modules/ConfigPurchase/CalendarPurchase'

const CronogramaCompraCalendar: FC = () => {
  const {
    actions,
    query,
    setFilename,
    loadingCronograma,
    fetching,
    companieId,
    cronogramaCompra,
    createCronogramaCompra,
    cronogramaLoadFailed
  } = useParametrizationConfigPurchase()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { companies: authCompanies } = useAuth()
  return (
    <Box>
      <LayoutTools
        title={'Cronograma Compra'}
        // filters={filters}
        actions={actions}
        query={query}
        onTitleChange={setFilename}
        isDisabled={
          loadingCronograma || fetching || cronogramaCompra.length === 0
        }
      />
      {loadingCronograma ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : authCompanies?.length === 0 ? (
        <LayoutEmpty
          type="chartEmpty"
          title="É necessário pelo menos 1 empresa cadastrada no perfil"
          message=""
        />
      ) : authCompanies?.length > 1 && Number(companieId) === 0 ? (
        <LayoutEmpty
          type="chartEmpty"
          title="Selecione ao menos 1 empresa"
          message="Filtre sua busca em cima para obter informações"
        />
      ) : (
        <Box>
          <Grid templateColumns={{ base: '1fr', md: 'repeat(1, 1fr)' }}>
            {/* Primeiro Item */}
            <GridItem>
              <PurchaseSchedule data={cronogramaCompra} />
              {/* <SpecialScheduleCompra
                initialSchedule={chapariaTimelineDefault}
                activeTimeline={activeTimelineChaparia}
                setActiveTimeLine={handleTimelineActiveChaparia}
                onScheduleChange={handleTimelineChapariaNormalyNew}
              /> */}
            </GridItem>

            {/* Segundo Item */}
          </Grid>
        </Box>
      )}

      {/* Botão de salvar fixo no canto inferior esquerdo */}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Configuração Compra
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            <Text>Desejar confirmar as configurações realizadas?</Text>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="green"
              onClick={() => {
                createCronogramaCompra()
                onClose()
              }}
            >
              Salvar
            </Button>
            <Button colorScheme="red" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Button
        position="fixed"
        bottom="20px"
        bg="green.600"
        color="white"
        right="20px"
        onClick={onOpen}
        // Salvar substitui o cronograma inteiro: bloqueado enquanto carrega ou se a carga falhou
        isDisabled={loadingCronograma || cronogramaLoadFailed}
        size="lg"
        leftIcon={<FaSave />}
        _hover={{ bg: 'green.600' }}
      >
        Salvar
      </Button>
    </Box>
  )
}

export default CronogramaCompraCalendar
